import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListContacts from '../../components/contact/list-contacts.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ContactsView = () => (
  <AppLayout pageTitle={PAGE_TITLE_LIST.CONTACTS}>
    <ListContacts />
  </AppLayout>
);

export default ContactsView;
